import { ClosedSangjoProps } from "@/types/sangjoType";
import { VStack } from "goi_common";

interface Props {
  companyName: ClosedSangjoProps["companyname"];
  status: ClosedSangjoProps["status"];
}

const ParlorClosedInformation = ({ companyName, status }: Props) => {
  return (
    <VStack as="section">
      <p className="body_14_m">
        {companyName}는 현재 {status} 상태입니다. 다른 상조 이용이 궁금하시다면 아래 버튼을 눌러
        문의해주세요.
      </p>
    </VStack>
  );
};

export default ParlorClosedInformation;
